const JUST_COMPLETED_STORAGE_KEY = "verbal.justCompletedSessionIds";

const readJustCompletedSessionIds = (): number[] => {
    try {
        const raw = sessionStorage.getItem(JUST_COMPLETED_STORAGE_KEY);
        if (!raw) {
            return [];
        }
        const parsed: unknown = JSON.parse(raw);
        if (!Array.isArray(parsed)) {
            return [];
        }
        return parsed.filter((id): id is number => typeof id === "number");
    } catch {
        return [];
    }
};

export const justCompletedSessionIds = (): Set<number> => new Set(readJustCompletedSessionIds());

/** Skip this session in Prepare/Deliver nav until active-programme stats refetch. */
export const rememberCompletedSession = (sessionId: number): void => {
    try {
        const ids = justCompletedSessionIds();
        ids.add(sessionId);
        sessionStorage.setItem(JUST_COMPLETED_STORAGE_KEY, JSON.stringify([...ids]));
    } catch {
        // Private mode / blocked storage — nav will catch up on the next stats fetch.
    }
};

export const isSessionDeliveryPath = (pathname: string): boolean => /(?:^|\/)start-session\/\d+/.test(pathname);

/** Hub routes used when nav has no next session (stale or empty active-programme stats). */
export const isSessionHubPath = (pathname: string): boolean => pathname === "/prepare" || pathname === "/deliver";
